import Toast from '@standardsdigital/ui-components/Toast';
import { useAppSelector } from '@/redux/hooks';
import getTranslation from '@/util/getTranslation';

interface ToastWrapperProps {
  translations: string | undefined;
}

function ToastWrapper({ translations: jsonTranslations }: ToastWrapperProps) {
  const translations: unknown = JSON.parse(jsonTranslations || '{}');
  const messages = useAppSelector((state) => state.messages);

  return (
    <Toast
      accessibleLabel={getTranslation('Common.Notification', translations)}
      messages={messages}
    />
  );
}

export default ToastWrapper;
